import React from 'react'
import PageWrapper from '../../components/PageWrapper'
import AddIcon from '../../assets/icons/AddIcon'
import ViewResidentIcon from '../../assets/icons/ViewResident'
import Tab from '../../components/Tab/Tab'
import ViewResidents from './ViewResident'
import AddResidents from './AddResidents'
import EditResidents from './EditResidents'
import Metadata from '../../components/Metadata'
import ResidentDetailsPage from './ResidentDetailsPage'
import { ResidentDTO } from '../../interfaces/resident'

const Residents = () => {
  const [numOfResidents, setNumOfResidents] = React.useState(0)
  const [currentView, setCurrentView] = React.useState('')
  const [loading, setLoading] = React.useState(true)
  const [selectedResident, setSelectedResident] = React.useState<ResidentDTO | null>(null)

  const isActiveView = (view: string) => {
    return view === currentView
  }

  const handleResidentCount = (num: number) => {
    setNumOfResidents(num)
  }

  const getQueryParams = () => {
    const params = new URLSearchParams(window.location.search)
    return {
      active: params.get('active') || 'view',
      id: params.get('id') || '',
    }
  }

  const handleViewSelect = (view: string, queries?: Record<string, string>) => {
    if (isActiveView(view)) {
      return
    }
    let queryArr = [`active=${view}`]
    for (let key in queries) {
      queryArr.push(`${key}=${queries[key]}`)
    }
    window.history.replaceState(null, '', `?${queryArr.join('&')}`)
    setCurrentView(view)
  }

  React.useEffect(() => {
    const search = window.location.search.substring(1)
    const searchObj = search
      ? JSON.parse(
          `{"${search.replace(/&/g, '","').replace(/=/g, '":"')}"}`,
          function (key, value) {
            return key === '' ? value : decodeURIComponent(value)
          }
        )
      : { active: 'view' }
    setLoading(false)

    setCurrentView(searchObj.active)
  }, [])

  React.useEffect(() => {}, [currentView])
  React.useEffect(() => {
    const { active } = getQueryParams()
    setCurrentView(active)
    setLoading(false)
  }, [])

  const renderViewModule = () => {
    const { id } = getQueryParams()
    switch (currentView) {
      case 'view':
        return (
          <ViewResidents
            setNumOfResidents={handleResidentCount}
            handleViewSelect={handleViewSelect}
            onViewDetails={setSelectedResident}
          />
        )
      case 'add':
        return <AddResidents handleViewSelect={handleViewSelect} />

      case 'edit':
        return (
          <EditResidents
            handleViewSelect={function (
              view: string,
              queries?: Record<string, string> | undefined
            ): void {}}
          />
        )

      case 'viewDetails':
        return (
          <ResidentDetailsPage
            residentId={id}
            resident={selectedResident}
            handleViewSelect={handleViewSelect}
          />
        )
      default:
        return <p>Loading</p>
    }
  }

  const residentsMetadata = {
    title: 'Residents - Safelto',
    description:
      'Manage residents, view resident information, and handle resident access and compliance. Complete resident management solution.',
    keywords: [
      'residents',
      'resident management',
      'resident information',
      'access control',
      'property management',
    ],
    image: '/assets/images/safelto-big.png',
    url: 'https://safelto.com/residents',
    type: 'website' as 'website',
  }

  return (
    <PageWrapper title="Residents" description="Manage residents access and compliance">
      <Metadata {...residentsMetadata} />
      {currentView !== 'viewDetails' && (
        <div className="justify-between flex flex-wrap">
          <div className="flex gap-10">
            <Tab
              text={'View Residents'}
              Icon={ViewResidentIcon}
              active={isActiveView('view')}
              onClick={() => handleViewSelect('view')}
            />
            <Tab
              text={'Add Resident'}
              Icon={AddIcon}
              active={isActiveView('add')}
              onClick={() => handleViewSelect('add')}
            />
          </div>

          <div className="flex gap-5 items-center p-2.5 whitespace-nowrap h-fit bg-gray-100 rounded-lg">
            <div className="flex bg-gray-900 w-9 h-9 rounded-xl items-center justify-center">
              <ViewResidentIcon active={true} />
            </div>
            <p className="">Total number of Residents: {numOfResidents}</p>
          </div>
        </div>
      )}
      <div>{!loading ? renderViewModule() : <p>Loading</p>}</div>
    </PageWrapper>
  )
}

export default Residents
